import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beba231a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "grid-parent",
  class: "grid my-0 mx-auto"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  id: "grid-parent",
  class: "grid mx-auto mt-5"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "v1.0.0")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_o_nav_bar = _resolveComponent("o-nav-bar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "top-left",
      group: "submission-error"
    }),
    (!_ctx.hideNavigation)
      ? (_openBlock(), _createBlock(_component_o_nav_bar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ]),
    _hoisted_3
  ], 64))
}